import { Collapse, withStyles } from '@material-ui/core';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import React, { useEffect, useRef, useState } from 'react';
import { compose } from 'recompose';

const styles = (theme) => ({
  container: {
    position: 'relative',
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  arrowDown: {
    cursor: 'pointer',
    transition: 'transform .2s ease-in-out',
    color: '#21212D',
    fontSize: 25,
    transform: 'rotate(180deg)',
  },
  arrowUp: {
    cursor: 'pointer',
    transition: 'transform .2s ease-in-out',
    color: '#21212D',
    fontSize: 25,
  },
  dropdownContent: {
    position: 'absolute',
    top: 'calc(100% + 5px)',
    left: 0,
    width: '100%',
	overflow: "auto",
	maxHeight: "400px",
    backgroundColor: '#fff',
    borderTop: 'none',
    borderRadius: '6px',
    boxShadow: '0px 6px 13px 0px rgba(102, 120, 163, 0.1)',
    zIndex: 10,
    padding: '8px',
    boxSizing: 'border-box',
	background: 'red',
  },
  textField: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  inputLabel: {
    fontFamily: 'Rubik',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: '#18181B',
    marginRight: '4px',
  },
  inputField: {
    width: '100%',
    padding: '7px 11px 7px 12px',
    border: '1px solid #F1F1F2',
    borderRadius: '6px',
    marginTop: '8px',
    fontFamily: 'Rubik',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    boxSizing: 'border-box',
    outline: 'none',
    resize: 'none',
	whiteSpace: 'nowrap',     
	overflow: 'hidden',     
	textOverflow: 'ellipsis', 
  },
  inputFieldError: {
    borderColor: 'red', 
  },
  inputFieldFocused: {
	// '&:focus': {
	// 	borderColor: '#7B4FF0',
	//   },
  },
  leftIconContainer: {
    position: 'absolute',
    left: '11px',
	top: '71%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  arrowWrap: {
    position: 'absolute',
    right: '11px',
    top: '75%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
  },
  subIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '4px',
  },
});


const _CollapsibleDropdown = ({
  label,
  content,
  readOnly = false,
  required = false,
  classes,
  placeholder = '',
  defaultValue,
  withInfoIcon = false,
  leftIcon,
  rightIcon,
  customStyles,
  onBlur,
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const dropdownRef = useRef(null);

  const toggleCollapsed = () => {
	if(readOnly) return
    setCollapsed(prev => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setCollapsed(true);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const inputClassName = `${classes.inputField} ${required && !defaultValue ? classes.inputFieldError : ''} ${ !readOnly ?  classes.inputFieldFocused : ""}`;

  return (
    <div className={classes.container} ref={dropdownRef}>
      <div onClick={toggleCollapsed} className={classes.textField}>
        <div className={classes.labelContainer}>
          <div className={classes.inputLabel}>{label}</div>
          {/* {required && <div className={classes.subIcon}><RequireInputIcon /></div>} */}
          {/* {withInfoIcon && <div className={classes.subIcon}><InputInfoIcon /></div>} */}
        </div>
        {leftIcon && <div className={classes.leftIconContainer}>{leftIcon}</div>}
        {rightIcon ? rightIcon : <div className={classes.arrowWrap}>
          {!collapsed ? (
            <KeyboardArrowDown className={classes.arrowDown} />
          ) : (
            <KeyboardArrowDown className={classes.arrowUp} />
          )}
        </div> }
        <input
		  onBlur={onBlur}
          value={defaultValue}
          type="text"
          readOnly={readOnly}
		  placeholder={placeholder}
          className={inputClassName}
          style={{
            paddingLeft: leftIcon ? '40px' : '12px',
            backgroundColor: readOnly
              ? 'rgba(183, 184, 189, 0.15)'
              : 'rgba(183, 184, 189, 0.07)',
            color: readOnly ? '#B7B8BD' : '#18181B',
			...customStyles,
          }}
        />
      </div>
      <Collapse in={!collapsed} timeout="auto" unmountOnExit={false}>
        {!collapsed && <div onClick={toggleCollapsed} className={classes.dropdownContent}>{content}</div>}
      </Collapse>
    </div>
  );
};

export const CollapsibleDropdown = compose(
    withStyles(styles, { withTheme: true }),   
)(_CollapsibleDropdown)